<template>
  <div class="the-nav" :class="{ 'mobile-mode': isMobileMode }">
    <div class="nav-header">
      <div class="nav-type clearfix">
        <div class="type-item"
             :class="{ active: currentTypeCode === item.code }"
             v-for="item in typeList"
             :key="item.code"
             @click="changeType(item)"><i :class="item.icon"></i>{{ item.name }}</div>
        <div class="cancel-nav" @click="cancelNav"><i class="ri-close-line"></i></div>
      </div>
      <div class="nav-point">
        <div class="point-exchange" @click="pointExchange"><i class="ri-arrow-up-down-fill"></i></div>
        <div class="point-list">
          <div class="start-point"><input type="text" id="startPoi" v-model="myPosition" :disabled="!isAble"></div>
          <div class="end-point"><input type="text"  v-model="arrivePos.name" :disabled="isAble"></div>
        </div>
      </div>
      <div class="nav-btn">
        <el-button type="text" size="small" class="remove-route" @click="clearTrip">清除路线</el-button>
        <el-button type="primary" size="small" class="submit-nav" @click="startTrip">{{ submitBtnText }}</el-button>
      </div>
    </div>
    <div class="nav-body" v-if="!isMobileMode">
      <el-scrollbar class="scrollbar">
        <div id="map-panel"></div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Bus from '@/api/bus'
import { $route } from '@/api/mapUtil'
export default {
  name: 'TheNav',
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    isMobileMode: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    data (newVal) {
      console.log(newVal)
    }
  },
  data () {
    return {
      isAble: true,
      currentTypeCode: '1',
      myPosition: '当前位置',
      typeList: [
        {
          code: '1',
          icon: 'ri-car-fill',
          name: '驾车',
          info: '开车去'
        },
        {
          code: '2',
          icon: 'ri-bus-fill',
          name: '公交',
          info: '坐公交'
        },
        {
          code: '3',
          icon: 'ri-walk-fill',
          name: '步行',
          info: '走路去'
        }
      ],
      inputVal: '',
    }
  },
  computed: {
    submitBtnText () {
      const that = this
      return _.find(that.typeList, function (item) {
        return item.code === that.currentTypeCode
      }).info
    },
    arrivePos () {
      const that = this
      return that.data
    }
  },
  methods: {
    changeType (typeItem) {
      const that = this
      that.currentTypeCode = typeItem.code
    },
    startTrip () {
      const that = this
      console.log("DATA",that.data)
      that.$emit('start', that.currentTypeCode,that.data)
    },
    clearTrip () {
       Bus.$emit('val', true)
      const that = this
      that.$emit('clear')
    },
    pointExchange () {
      const that = this
      const pos = that.arrivePos.name
      that.arrivePos.name = that.myPosition
      that.myPosition = pos
      that.$store.commit('reserveTrip')
      that.isAble = !that.isAble
    },
    cancelNav () {
      const that = this
      that.$emit('cancel-nav')
    },
    startSelectFn(e) {
      this.$store.commit('setStartPos', e.poi.location)
    }
  },
  mounted() {
    $route.placeSearch('startPoi', this.startSelectFn)
  }
}
</script>

<style lang="scss" scoped>
@import "~@style/_var.scss";
@import "~@style/_theme.scss";
.the-nav {
  position: absolute;
  z-index: 9;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  padding-top: 192px;
  background-color: $sidebarBgColor;
  &.mobile-mode{
    $tabHeight: 36px;
    position: relative;
    padding-top: 0;
    background-color: transparent;
    .nav-header{
      position: relative;
      height: auto;
      padding-bottom: 8px;
      border-bottom: none;
    }
    .nav-type{
      .type-item{
        height: $tabHeight;
        line-height: $tabHeight;
      }
      .cancel-nav{
        height: $tabHeight;
        line-height: $tabHeight;
      }
    }
    .nav-point .point-list > div{
      height: 32px;
      line-height: 32px;
    }
    .nav-btn{
      margin-top: 4px;
    }
  }
  .nav-header{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 192px;
    border-bottom: 5px solid #F5F7FA;
  }
  .nav-type{
    position: relative;
    padding-right: 40px;
    border-bottom: 1px solid $borderColorPrimary;
    .type-item{
      position: relative;
      float: left;
      width: 33.33%;
      height: 48px;
      line-height: 48px;
      text-align: center;
      cursor: pointer;
      transition: $transitionTime;
      i{
        margin-right: 4px;
        font-size: 16px;
        vertical-align: -2px;
      }
      &:hover,
      &.active{
        color: $colorPrimary;
      }
      &.active{
        &:before{
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          bottom: -1px;
          width: 0;
          height: 0;
          margin: 0 auto;
          border-style: solid;
          border-width: 0 5px 6px;
          border-color: transparent transparent $borderColorPrimary;
        }
        &:after{
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          bottom: -1px;
          width: 0;
          height: 0;
          margin: 0 auto;
          border-style: solid;
          border-width: 0 3px 4px;
          border-color: transparent transparent #fff;
        }
      }
    }
    .cancel-nav{
      position: absolute;
      right: 0;
      top: 0;
      width: 40px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      color: $colorTextSecondary;
      cursor: pointer;
      &:before{
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 1px;
        height: 14px;
        margin: auto 0;
        background-color: #E3E3E3;
      }
      &:hover{
        color: $colorPrimary
      }
      i{
        font-size: 16px;
      }
    }
  }
  .nav-point{
    position: relative;
    padding-left: 40px;
    .point-exchange{
      position: absolute;
      left: 10px;
      top: 0;
      bottom: 0;
      width: 20px;
      height: 20px;
      margin: auto 0;
      line-height: 20px;
      text-align: center;
      color: $colorTextSecondary;
      cursor: pointer;
      &:hover{
        color: $colorPrimary;
      }
      i{
        font-size: 16px;
      }
    }
    .point-list{
      &>div{
        position: relative;
        height: 40px;
        padding-left: 16px;
        padding-right: $paddingHorizontal;
        line-height: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:before{
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          width: 8px;
          height: 8px;
          margin: auto 0;
          border: 2px solid transparent;
          border-radius: 50%;
        }
      }
      input{
        display: block;
        width: 100%;
        height: 100%;
        background-color: transparent;
        border: none;
      }
      .start-point{
        &:before{
          border-color: #8BDE8C;
        }
      }
      .end-point{
        &:before{
          border-color: #FF9294;
        }
        border-top: 1px solid $borderColorPrimary;
      }
    }
  }
  .nav-btn{
    padding: 0 $paddingHorizontal;
    margin-top: 8px;
    overflow: hidden;
    .remove-route{
      float: left;
    }
    .submit-nav{
      float: right;
    }
  }
  .nav-body{
    height: 100%;
  }
}
</style>
